import templatesBundle from './data/authoredNarrativeTemplates.json';
import closeoutBundle from './data/peopleBuildingsCloseoutTemplates.json';

export type AuthoredMethodology = {
  sources: string;
  calculation: string;
  limitations: string;
  technical: string;
  source_urls?: string;
};

export type AuthoredNarrativeTemplate = {
  chart_id: string;
  view_id: string;
  route?: string;
  authoring_status: string;
  priority?: string;
  overview: string;
  key_insights_template: string;
  required_facts?: string;
  conditions?: string;
  relevance: string;
  equity: string;
  methodology: AuthoredMethodology;
  implementation_notes?: string;
  kpi_contract?: string;
};

type Bundle = { templates: AuthoredNarrativeTemplate[] };

const bundle = templatesBundle as Bundle;

const byKey = new Map<string, AuthoredNarrativeTemplate>();
for (const t of bundle.templates) {
  byKey.set(`${t.chart_id}|${t.view_id}`, t);
}
const closeout = closeoutBundle as Bundle;
for (const t of closeout.templates) {
  byKey.set(`${t.chart_id}|${t.view_id}`, t);
}

export function getAuthoredTemplate(
  chartId: string,
  viewId: string
): AuthoredNarrativeTemplate | undefined {
  return byKey.get(`${chartId}|${viewId}`) ?? byKey.get(`${chartId}|default`);
}

/** Only fully verified authoring statuses may auto-publish ChatGPT methodology blocks. */
export function shouldPublishAuthoredMethodology(status: string): boolean {
  return (
    status === 'READY' ||
    status === 'READY_INHERIT' ||
    status === 'KEEP'
  );
}

export function isImplementableAuthoredStatus(status: string): boolean {
  return (
    status.startsWith('READY') ||
    status === 'KEEP'
  );
}
